import Badge from '../../components/layout/Badge';
import { mdiTag } from '@mdi/js';
import Icon from '@/components/Icon';

export const BadgeMarcadores = ({ marcadores, style }: { marcadores: string[], style?: React.CSSProperties }) => {
  return marcadores
    ?.filter((m: any) => m !== 'TRANSFERIDO')
    ?.map((m: any) => (
      <Badge variant="light" key={m} style={style}>
        <Icon path={mdiTag} size={0.75} />
        {m}
      </Badge>
    ));
};
